import React from "react";
import Button from "components/button";
import Icon from "components/icon";
import ActionMenu from "components/shared/action-menu";
import { DriverDraftRow } from "../types";

export const DriverCell = ({ row }: { row: DriverDraftRow }) => (
  <div className="flex items-center gap-3 group">
    <div className="h-10 w-10 overflow-hidden rounded-full bg-greyScale-100 border border-border group-hover:border-primary-500 transition-colors flex items-center justify-center">
      {row.driverPicture ? (
        <img 
          src={row.driverPicture} 
          alt={row.driverName} 
          className="h-full w-full object-cover"
          onError={(e) => {
            (e.target as any).src = "";
          }}
        />
      ) : (
        <Icon name="profile-2user" size={16} className="text-neutral-400" />
      )}
    </div>
    <div className="flex flex-col">
      <span className="font-bold text-sm text-slate-900 group-hover:text-primary-600 transition-colors">
        {row.driverName || "-"}
      </span>
    </div>
  </div>
);

export const StatusCell = ({ row, t }: { row: DriverDraftRow, t?: any }) => {
  const statusStyles: Record<string, string> = {
    Available: "bg-[#F0FDF4] text-[#166534]",
    Assigned: "bg-[#FFFBEB] text-[#92400E]",
    Maintenance: "bg-[#FEF2F2] text-[#991B1B]",
    Inactive: "bg-[#F8FAFC] text-[#475569]",
    Draft: "bg-greyScale-100 text-greyScale-600",
  };
  const style = statusStyles[row.status] || "bg-greyScale-100 text-greyScale-600";
  return (
    <div className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium capitalize ${style}`}>
      {row.status}
    </div>
  );
};

export const ActionCell = ({ 
  row, 
  t, 
  handleEditRequest,
  handleDeleteRequest 
}: { 
  row: DriverDraftRow, 
  t: any, 
  handleEditRequest: (id: string) => void,
  handleDeleteRequest: (row: DriverDraftRow) => void
}) => (
  <div className="flex items-center gap-2" onClick={(e) => e.stopPropagation()}>
    <Button
      type="button"
      variant="outline"
      color="tertiary"
      size="small"
      iconLeft={<Icon name="edit-2" size={14} />}
      onClick={() => handleEditRequest(row.id)}
      className="px-3"
      data-testid={`btn-edit-draft-${row.id}`}
    >
      {t("btn-edit")}
    </Button>
    <ActionMenu
      items={[
        { label: t("btn-delete"), onClick: () => handleDeleteRequest(row), variant: "danger" as const, testId: `btn-delete-draft-${row.id}` },
      ]}
    />
  </div>
);
